export default "__VITE_ASSET__RxRb8Zjo__"